import { SvgIcon, SvgIconProps } from '@/theme/index';

export function DollarsAndCoinsIcon(props: SvgIconProps) {
  return (
    <SvgIcon viewBox="0 0 46 46" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.625 11.047V22.297C28.625 23.457 32.401 24.407 37.063 24.407C41.724 24.407 45.5 23.457 45.5 22.297V11.047C45.5 12.212 41.722 13.157 37.062 13.157C32.402 13.157 28.625 12.212 28.625 11.047Z"
        fill="#F2DA3E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.5 11.047C45.5 12.212 41.722 13.157 37.062 13.157C32.402 13.157 28.625 12.212 28.625 11.047C28.625 9.882 32.403 8.937 37.063 8.937C41.723 8.937 45.5 9.883 45.5 11.047Z"
        fill="#FEF4B6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.625 15.584C30.538 16.657 34.614 16.98 37.063 16.98C39.511 16.98 43.587 16.657 45.5 15.584V14.21C45.5 14.723 42.63 15.924 37.062 15.924C31.496 15.924 28.625 14.723 28.625 14.21V15.584ZM28.625 19.803C30.538 20.876 34.614 21.198 37.063 21.198C39.511 21.198 43.587 20.876 45.5 19.803V18.429C45.5 18.943 42.63 20.144 37.062 20.144C31.496 20.144 28.625 18.943 28.625 18.429V19.803Z"
        fill="#E1C618"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.625 22.675C28.625 23.045 30.134 23.775 33.069 24.151L36.014 21.206C33.573 21.126 30.286 20.76 28.625 19.829V22.675ZM28.625 15.61V18.456C28.625 18.969 31.492 20.168 37.051 20.17L40.381 16.84C39.178 16.958 38.001 17.006 37.062 17.006C34.614 17.006 30.538 16.683 28.625 15.611M37.063 13.183C32.403 13.183 28.625 12.239 28.625 11.073V14.238C28.625 14.75 31.495 15.952 37.063 15.952C38.848 15.952 40.353 15.827 41.578 15.642L45.5 11.72V11.073C45.5 12.239 41.723 13.183 37.063 13.183Z"
        fill="#FBED91"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.625 14.238V15.611C30.538 16.683 34.614 17.006 37.063 17.006C38.001 17.006 39.178 16.958 40.381 16.839L41.578 15.642C40.353 15.827 38.848 15.952 37.062 15.952C31.496 15.952 28.625 14.75 28.625 14.238ZM28.625 18.456V19.829C30.285 20.76 33.573 21.126 36.015 21.206L37.051 20.17C31.491 20.168 28.625 18.969 28.625 18.456ZM20.188 4.71899C15.528 4.71899 11.75 3.77399 11.75 2.60899V21.594C11.75 22.754 15.526 23.704 20.188 23.704C24.849 23.704 28.625 22.754 28.625 21.594V2.60899C28.625 3.77399 24.848 4.71899 20.188 4.71899Z"
        fill="#F2DA3E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.625 2.61C28.625 3.774 24.847 4.719 20.187 4.719C15.527 4.719 11.75 3.774 11.75 2.609C11.75 1.444 15.528 0.5 20.188 0.5C24.848 0.5 28.625 1.444 28.625 2.61Z"
        fill="#FEF4B6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.75 7.146C13.663 8.219 17.739 8.542 20.188 8.542C22.636 8.542 26.712 8.219 28.625 7.146V5.77299C28.625 6.286 25.755 7.487 20.187 7.487C14.621 7.487 11.75 6.28699 11.75 5.77299V7.146ZM11.75 11.365C13.663 12.438 17.739 12.761 20.188 12.761C22.636 12.761 26.712 12.438 28.625 11.365V9.99199C28.625 10.505 25.755 11.706 20.187 11.706C14.621 11.706 11.75 10.506 11.75 9.99199V11.365ZM11.75 15.584C13.663 16.657 17.739 16.98 20.188 16.98C22.636 16.98 26.712 16.657 28.625 15.584V14.21C28.625 14.723 25.755 15.924 20.187 15.924C14.621 15.924 11.75 14.723 11.75 14.21V15.584ZM11.75 19.143C13.663 20.216 17.739 20.539 20.188 20.539C22.636 20.539 26.712 20.216 28.625 19.143V17.77C28.625 18.284 25.755 19.484 20.187 19.484C14.621 19.484 11.75 18.284 11.75 17.77V19.143Z"
        fill="#E1C618"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.75 17.76C11.75 17.975 12.258 18.309 13.246 18.625L15.271 16.6C13.891 16.382 12.605 16.053 11.75 15.574V17.76ZM11.75 14.201C11.75 14.571 13.259 15.301 16.194 15.677L19.139 12.732C16.698 12.652 13.411 12.286 11.75 11.355V14.201ZM11.75 7.136V9.982C11.75 10.495 14.617 11.694 20.176 11.696L23.506 8.366C22.303 8.484 21.126 8.532 20.187 8.532C17.739 8.532 13.663 8.209 11.75 7.136ZM20.188 4.709C15.528 4.709 11.75 3.764 11.75 2.599V5.763C11.75 6.276 14.62 7.478 20.188 7.478C21.973 7.478 23.478 7.353 24.703 7.168L28.625 3.246V2.6C28.625 3.765 24.847 4.71 20.187 4.71"
        fill="#FBED91"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.75 19.2V20.187L12.426 19.512C12.181 19.415 11.951 19.312 11.75 19.199"
        fill="#FBE158"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.75 5.763V7.137C13.663 8.209 17.739 8.532 20.188 8.532C21.126 8.532 22.303 8.484 23.506 8.365L24.703 7.168C23.478 7.353 21.973 7.478 20.188 7.478C14.621 7.478 11.75 6.276 11.75 5.763ZM11.75 9.982V11.355C13.41 12.286 16.698 12.652 19.14 12.732L20.176 11.696C14.616 11.694 11.75 10.495 11.75 9.982ZM11.75 14.201V15.574C12.605 16.053 13.892 16.382 15.271 16.6L16.194 15.677C13.26 15.3 11.75 14.573 11.75 14.201Z"
        fill="#F2DA3E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.75 17.826V19.2C11.951 19.312 12.181 19.415 12.426 19.512L13.246 18.692C12.258 18.375 11.75 18.041 11.75 17.826Z"
        fill="#FACB1B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.422 15.266V32.14C22.297 40.577 22.297 32.14 39.172 40.577V23.703C22.297 15.266 22.297 23.703 5.422 15.266ZM7.532 18.582C14.463 21.594 18.437 21.594 22.297 21.594C26.176 21.594 29.851 21.594 37.062 25.021V37.261C30.13 34.25 26.157 34.25 22.297 34.25C18.417 34.25 14.742 34.25 7.531 30.823V18.583"
        fill="#81B44C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.063 37.261V25.021C29.851 21.594 26.176 21.594 22.297 21.594C18.437 21.594 14.463 21.594 7.53101 18.582V30.823C14.743 34.25 18.418 34.25 22.297 34.25C26.157 34.25 30.131 34.25 37.063 37.261Z"
        fill="#638A3A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M26.516 27.922C26.516 30.252 24.626 32.141 22.296 32.141C19.967 32.141 18.078 30.252 18.078 27.921C18.078 25.591 19.968 23.703 22.297 23.703C24.627 23.703 26.516 25.592 26.516 27.922Z"
        fill="#81B44C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.422 15.613V32.14C9.049 33.954 11.894 34.984 14.297 35.574L16.069 33.801C13.784 33.367 11.089 32.512 7.531 30.821V18.581C14.463 21.593 18.437 21.593 22.297 21.593C24.094 21.593 25.851 21.598 27.932 21.938L29.732 20.138C21.445 18.291 18.411 21.695 5.656 15.378L5.422 15.613Z"
        fill="#C3DBA9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.932 21.94C25.852 21.598 24.094 21.594 22.297 21.594C18.437 21.594 14.463 21.594 7.53101 18.582V30.823C11.088 32.513 13.784 33.368 16.069 33.803L27.932 21.939V21.94Z"
        fill="#81B44C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.297 23.703C19.967 23.703 18.078 25.592 18.078 27.922C18.078 28.998 18.485 29.978 19.148 30.723L25.098 24.773C24.353 24.11 23.373 23.703 22.297 23.703Z"
        fill="#C3DBA9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.5 20.188V37.063C17.375 45.5 17.375 37.063 34.25 45.5V28.625C17.375 20.187 17.375 28.626 0.5 20.188ZM2.61 23.504C9.541 26.516 13.516 26.516 17.375 26.516C21.255 26.516 24.929 26.516 32.141 29.943V42.183C25.209 39.172 21.234 39.172 17.375 39.172C13.495 39.172 9.821 39.172 2.609 35.745V23.505"
        fill="#81B44C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M32.14 42.183V29.943C24.93 26.516 21.254 26.516 17.375 26.516C13.515 26.516 9.54101 26.516 2.60901 23.504V35.744C9.82101 39.172 13.496 39.172 17.375 39.172C21.235 39.172 25.209 39.172 32.141 42.183"
        fill="#638A3A"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.594 32.844C21.594 35.174 19.704 37.062 17.375 37.062C15.045 37.062 13.156 35.174 13.156 32.844C13.156 30.514 15.046 28.625 17.375 28.625C19.705 28.625 21.594 30.514 21.594 32.844Z"
        fill="#81B44C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.5 20.535V37.062C4.127 38.876 6.972 39.907 9.375 40.496L11.147 38.724C8.862 38.29 6.167 37.435 2.609 35.744V23.504C9.541 26.516 13.516 26.516 17.375 26.516C19.172 26.516 20.929 26.52 23.011 26.861L24.811 25.061C16.524 23.214 13.489 26.618 0.734 20.301L0.5 20.535Z"
        fill="#C3DBA9"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M23.01 26.861C20.93 26.52 19.172 26.516 17.375 26.516C13.515 26.516 9.54201 26.516 2.60901 23.504V35.745C6.16701 37.435 8.86201 38.29 11.147 38.725L23.011 26.86L23.01 26.861Z"
        fill="#81B44C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.375 28.625C15.045 28.625 13.156 30.514 13.156 32.844C13.156 33.92 13.563 34.9 14.226 35.645L20.176 29.695C19.431 29.031 18.451 28.625 17.375 28.625Z"
        fill="#C3DBA9"
      />
    </SvgIcon>
  );
}
